.container {
    line-height: 1.4;
    display: flex;
    height: 100%;
    margin-bottom: 4px;
}

.input,
.button,
.button--required {
    width: 100%;
    height: fit-content;
    padding: 0;
}

.input {
    line-height: 1.4;
}

.input::placeholder {
    color: var(--placeholder);
}

.input:focus {
    box-sizing: border-box;
    border: none;
    outline: none;
}

.button {
    white-space: pre-wrap;
    text-align: unset; /* This overrides out default button style */
    padding-bottom: 0.5px; /* This prevents a tiny jump when the input is selected */
    display: flex;
    align-items: center;
    gap: 8px;
    word-break: break-word;
}

.button--required {
    white-space: pre-wrap;
    text-align: unset; /* This overrides out default button style */
    padding-bottom: 0.5px; /* This prevents a tiny jump when the input is selected */
    right: -7px;
    display: flex;
    align-items: center;
    gap: 4px;
    word-break: break-word;
}

.button--empty {
    color: var(--placeholder);
}

.button--saving {
    color: var(--grey-lt);
    cursor: default;
}

.button--required::after {
    content: '*';
    font-weight: 700;
    padding-left: 2px;
}

.button:hover,
.button--required:hover {
    background-color: white;
}

.button:disabled,
.button--required:disabled {
    background-color: white;
}
